export default "__VITE_ASSET___aeyK6gU__"